import { store } from "@/store";
import { observer } from "mobx-react-lite";

export const AvatarDragOverlay = observer(() => {
  return (
    <>
      {store.avatarPosition.isDragging && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: "var(--pyne-layer-max)",
            pointerEvents: "none",
            userSelect: "none",
          }}
        ></div>
      )}
      <style>{store.avatarPosition.stylesheetContent}</style>
    </>
  );
});
